export default __webpack_public_path__ + "static/media/1605.adc1f6b3.png";